





















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import moment from "moment";

function getScrollParent(el: HTMLElement | null): HTMLElement | Window {
  let parent: HTMLElement | null = el ? el.parentElement : null;
  while (parent) {
    const style = window.getComputedStyle(parent);
    // consider both axes
    if (/(auto|scroll|overlay)/.test(style.overflowY) || /(auto|scroll|overlay)/.test(style.overflow)) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return window; // fallback
}

@Component
export default class EventPopover extends Vue {
  @Prop({ required: true }) event!: any;
  @Prop({ required: true }) target!: HTMLElement;
  @Prop({ default: false }) visible!: boolean;

  private position = { top: 0, left: 0 };
  private scrollParent: HTMLElement | Window | null = null;
  private onScrollOrResize = () => this.updatePosition();

  mounted() {
    if (this.visible) this.$nextTick(() => this.start());
  }

  beforeDestroy() {
    this.stop();
  }

  @Watch("visible")
  onVisibleChange(v: boolean) {
    if (v) this.$nextTick(() => this.start());
    else this.stop();
  }

  @Watch("target")
  onTargetChange() {
    if (this.visible)
      this.$nextTick(() => {
        this.stop();
        this.start();
      });
  }

  // If your popover content changes when event changes, you can also watch event:
  // @Watch("event")
  // onEventChange() { if (this.visible) this.$nextTick(() => this.updatePosition()); }

  private start() {
    this.updatePosition(); // initial pass
    window.addEventListener("resize", this.onScrollOrResize, { passive: true });
    this.scrollParent = getScrollParent(this.target);
    (this.scrollParent as any).addEventListener?.("scroll", this.onScrollOrResize, { passive: true });
  }

  private stop() {
    window.removeEventListener("resize", this.onScrollOrResize);
    (this.scrollParent as any)?.removeEventListener?.("scroll", this.onScrollOrResize);
    this.scrollParent = null;
  }

  private updatePosition() {
    const popEl = this.$refs.popover as HTMLElement | undefined;
    if (!this.target || !popEl) return;

    // Measure anchor & popover
    const rect = this.target.getBoundingClientRect();

    const { width: popW, height: popH } = popEl.getBoundingClientRect();
    const margin = 8;

    // Prefer "below"; if not enough room, flip "above"
    let top = rect.bottom + margin;
    if (top + popH > window.innerHeight - 8) {
      top = rect.top - popH - margin;
    }
    // If still off-screen, clamp to viewport
    if (top < 8) {
      top = Math.max(8, rect.bottom + margin);
    }

    // Center horizontally relative to the target; clamp to viewport
    let left = rect.left + rect.width / 2 - popW / 2;
    left = Math.max(8, Math.min(left, window.innerWidth - popW - 8));

    // Avoid micro-jitter by rounding;
    this.position = { top: Math.round(top), left: Math.round(left) };
  }

  public get note(): string {
    return this.event?.extendedProps?.note || "N/A";
  }

  get linkUrl(): string {
    const ex = this.event?.extendedProps || {};
    return this.event?.linkUrl ?? ex.linkUrl ?? "";
  }
}
